import { customerHomePath } from './customerHome';

export const ROLE_REDIRECTS = {
  CUSTOMER: customerHomePath,
  VENDOR: '/',
  DELIVERY: '/',
  ADMIN: '/',
};

export const getRedirectPathForRole = (role) => ROLE_REDIRECTS[role] || '/';

export const getAuthReturnPath = (from, role) => {
  if (typeof from !== 'string' || !from.startsWith('/') || /^\/[/\\]/.test(from)
    || /[\\\s]/.test(from) || /^\/auth\/?(?:[?#]|$)/i.test(from)) {
    return getRedirectPathForRole(role);
  }
  return from;
};

export const decodeJwt = (token) => {
  if (!token || typeof token !== 'string') return null;

  try {
    const segments = token.split('.');
    if (segments.length < 2) return null;

    const payload = segments[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const decoded = atob(padded);
    const normalized = decodeURIComponent(
      decoded
        .split('')
        .map((character) => `%${`00${character.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );

    return JSON.parse(normalized);
  } catch (error) {
    return null;
  }
};

export const getUserFromToken = (token) => {
  const decoded = decodeJwt(token);
  if (!decoded) return null;
  if (typeof decoded.exp === 'number' && decoded.exp * 1000 <= Date.now()) return null;

  return {
    id: decoded.userId || decoded.id || null,
    role: decoded.role || null,
    email: decoded.email || null,
    phone: decoded.phone || '',
    authProvider: decoded.authProvider || 'LOCAL',
    verified: Boolean(decoded.verified),
  };
};

// Portal URLs identify trusted app origins; sessions remain local to each origin.
export const getPortalUrlForRole = (role) => {
  const configured = {
    CUSTOMER: process.env.REACT_APP_CUSTOMER_URL,
    VENDOR: process.env.REACT_APP_VENDOR_URL,
    ADMIN: process.env.REACT_APP_ADMIN_URL,
    DELIVERY: process.env.REACT_APP_DELIVERY_URL,
  };
  if (!Object.hasOwn(configured, role) || !configured[role]) return null;
  try {
    const url = new URL(configured[role]);
    return ['http:', 'https:'].includes(url.protocol) ? url.origin + '/' : null;
  } catch {
    return null;
  }
};
